import { render, staticRenderFns } from "./LabelSelect.vue?vue&type=template&id=231cce34&"
import script from "./LabelSelect.vue?vue&type=script&lang=js&"
export * from "./LabelSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports